export default __webpack_public_path__ + "static/media/pepperoni-hot-peppers.78071c9c.png";